import { useSelector } from 'react-redux'
import { SurveyConfig } from 'src/redux/slices/project/consts'
import { selectSurveyProgress } from 'src/redux/slices/project/selectors'
import { SurveyProgress } from 'src/redux/slices/project/types'

import {
  AccordionSummary,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionHeading: {},
    accordionSecondary: {},
  }),
)

type SurveySectionHeadingPops = {
  // TODO: should be keyof something
  group: keyof SurveyProgress
  isDrawer?: boolean
}

const SurveySectionHeading: React.FC<SurveySectionHeadingPops> = ({ group, isDrawer }) => {
  const classes = useStyles()
  const surveyProgress = useSelector(selectSurveyProgress)
  const config = SurveyConfig[group]
  return (
    <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`survey-panel-${group}`}>
      <Grid container alignItems='center' spacing={2}>
        <Grid item>
          <Typography className={classes.sectionHeading} variant={isDrawer ? 'overline' : 'h5'}>
            {config.title}
          </Typography>
        </Grid>
        <Grid item>
          {surveyProgress[group].complete ? (
            <IconButton size='small' color='primary'>
              <CheckCircleIcon />
            </IconButton>
          ) : (
            <Typography variant='caption' className={classes.accordionSecondary}>
              {surveyProgress[group].completed} / {config.total}
            </Typography>
          )}
        </Grid>
      </Grid>
    </AccordionSummary>
  )
}
export default SurveySectionHeading
